export default "__VITE_ASSET__7oAs0Hrc__"